import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const stories = [
  { n: "Ajay Bhatt", r: "Inventor of USB", u: "MS · City University of New York" },
  { n: "Vinod Dham", r: "Inventor of Pentium processor", u: "MS · University of Cincinnati" },
  { n: "Sabeer Bhatia", r: "Founder of Hotmail", u: "MS · Stanford University" },
  { n: "Ruchi Sanghvi", r: "First woman engineer at Facebook", u: "MS · Carnegie Mellon" },
  { n: "Sanjay Mehrotra", r: "Co-founder, SanDisk", u: "MS · UC Berkeley" },
  { n: "Shantanu Narayen", r: "CEO, Adobe Systems", u: "MS · Bowling Green State, Ohio" },
  { n: "Amar Bose", r: "Founder, Bose Corporation", u: "MS · MIT" },
  { n: "Dhiraj Rajaram", r: "Founder, Mu Sigma Inc.", u: "MS · Wayne State University" },
];

export default function FutureYou() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const headRot = useTransform(scrollYProgress, [0, 1], [-2, 2]);

  return (
    <section ref={ref} className="grid-bg py-20 md:py-28 bg-white border-y-[3px] border-[#282829] overflow-hidden" data-testid="future-you-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <motion.div style={{ rotate: headRot }} className="text-center mb-12">
          <span className="inline-block bg-[#282829] text-white text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full border-2 border-[#282829] -rotate-2">Future You</span>
          <h2 className="font-display text-5xl md:text-7xl mt-4 leading-[0.9]">
            They went abroad.<br /><span className="gradient-text-rb">Then changed the world.</span>
          </h2>
          <p className="mt-5 text-[#282829]/65 max-w-2xl mx-auto">
            Inspiring stories of MS-abroad alumni who built USB, Hotmail, Pentium, Adobe & more. Yours could be next.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stories.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40, z: -200, rotateX: -25 }}
              whileInView={{ opacity: 1, y: 0, z: 0, rotateX: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, type: "spring", stiffness: 70 }}
              whileHover={{ rotate: i % 2 ? 2 : -2, y: -6, scale: 1.02 }}
              style={{ transformPerspective: 800 }}
              className={`p-5 rounded-3xl border-2 border-[#282829] ${
                i % 4 === 0 ? "bg-[#c92e34] text-white brutal-shadow-ink" :
                i % 4 === 1 ? "bg-white" :
                i % 4 === 2 ? "bg-[#282829] text-white brutal-shadow-ink" : "bg-[#FAFAFA]"
              }`}
              data-testid={`future-you-card-${i}`}
            >
              <div className="font-display text-2xl leading-tight">{s.n}</div>
              <div className="text-xs font-bold uppercase tracking-widest mt-2 opacity-80">{s.r}</div>
              <div className="text-xs mt-4 opacity-70">{s.u}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
